export default __webpack_public_path__ + "static/media/superhero.2ebdfc5c.svg";